"use strict";
exports.__esModule = true;
exports.HOW_YOU_USE_FLEX_CONTENT = void 0;
exports.HOW_YOU_USE_FLEX_CONTENT = {
    HEADER: 'How would you like to use Flex?',
    SUB_HEADER: 'We have options for everyone! Choose the one that best applies to your financial goals.',
    CREDIT_BUILDER_PRODUCT: {
        TITLE: 'Credit Builder',
        SUB_TITLE: '+45 points in 3 months*',
        FEE: '{{creditBuilderFee}}/month',
        CONTENT: 'Build credit by paying rent in full and on time. Flex will report your credit line use and payment history, which can improve your credit score.'
    },
    SPLIT_RENT_PRODUCT: {
        TITLE: 'Flexible Rent',
        SUB_TITLE: 'Split rent into 2 payments',
        FEE: '{{flexibleRentFee}}/month',
        CONTENT: 'Improve your cash flow by paying for rent over the course of the month instead of all at once.'
    },
    CTA: 'Continue',
    DISCLAIMER: 'Fees are estimated based on a {{estimatedRent}} rent bill when paying with a debit card',
    CREDIT_BUILDER_DISCLAIMER: '*Average outcome for customers with a starting VantageScore 3.0 credit score of 580–620.',
    CREDIT_BUILDER_LINK: 'Learn more'
};
